import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ApplicationRef,
  ChangeDetectorRef
} from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { AmountFilter, Order } from '../order.interface';
import { OrderFormComponent } from '../order-form/order-form.component';
import { WsService } from '../../shared/services/ws.service';
import { timer } from 'rxjs/observable/timer';
import { catchError, debounceTime, takeUntil, tap, mergeMap } from 'rxjs/operators';
import { StateService } from '../../shared/services/state.service';
import { of } from 'rxjs/observable/of';
import { _throw } from 'rxjs/observable/throw';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { SipWsService } from '../services/sip-ws.service';
import { DialogStatusService } from '@app/dashboard/services/dialog-status.service';
import { DriverNoticeComponent } from '@app/driver-notice/driver-notice/driver-notice.component';
import { CacheService } from '@app/shared/services/cache.service';
import { Client, SettingsService, ProductsService, ModalCloseComponent } from '@app/shared';
import { TimezoneService } from '@app/shared/services/timezone.service';
import { TaxiServiceInfoService } from '../services/taxi-service-info.service';
import { interval } from 'rxjs/observable/interval';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('controlMenu') controlMenu: TemplateRef<any>;
  @ViewChild('titlePage') titlePage: TemplateRef<any>;
  @ViewChild('orderDetails') orderDetComp: OrderDetailComponent;

  dialogRef: MatDialogRef<OrderFormComponent | ModalCloseComponent>;
  title = 'INTERFACE_SUPERVISOR';
  operatorID = localStorage.getItem('user_id');
  processing = false;
  filters = {
    method: {
      phone: false,
      app: false
    },
    orderType: {
      preordered: false,
      current: false
    },
    status: {
      processing: false,
      accepted: false,
      waiting: false,
      in_progress: false,
      completed: false
    },
    payment: {
      cash: false,
      bonus: false,
      card: false,
      phone: false
    }
  };
  filterAmount: AmountFilter;

  search: string = null;
  conveyor = false;
  myOrders = false; // TODO orders created by current operator
  activeFilter: {} = {};
  clearFilter = false; // TODO constant for change filter status check all/ clear all
  openedWindow = false;
  orders: Order[] = [];
  filteredOrders: Order[] = [];
  selectedTaxiServices = [];
  filter$ = new Subject();
  WebWorker: Worker;
  TickFilterOrder$: Subject<any> = new Subject();
  Ticker: Observable<any>;
  taxiServices: any;
  Products: any;
  driversStatus = false;
  selectedOrder: Order = null;
  OrderReady = false;
  allServices = [];
  driverNumberByService = {};
  ordersCountByService = {};
  cabsOnlineByService = {};

  haveSubscription = false;
  private componentDestroyed = new Subject();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private ws: WsService,
    private state: StateService,
    private cache: CacheService,
    private client: Client,
    private wsSip: SipWsService,
    private cd: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private timezone: TimezoneService,
    private settings: SettingsService,
    public dialogStatus: DialogStatusService,
    private taxiServiceInfoService: TaxiServiceInfoService,
    private productService: ProductsService
  ) {}

  ngOnInit() {
    this.filterAmount = this.getEmptyAmount();
    this.filter$
      .pipe(
        debounceTime(500),
        tap(data => {
          if (typeof data === 'object') {
            let obj: {} = data;
            let returnObj = {};
            for (let prop of Object.keys(obj)) {
              let obj1 = obj[prop];
              returnObj[prop] = [];
              for (let prop1 of Object.keys(obj1)) {
                if (obj1[prop1] === true) {
                  returnObj[prop].push(prop1);
                }
              }
            }
            for (let key in returnObj) {
              if (returnObj[key].length === 0) {
                delete returnObj[key];
              }
            }
            this.activeFilter = returnObj;
          } else if (typeof data === 'string') {
            this.search = (<string>data).trim();
          }
        }),
        takeUntil(this.componentDestroyed)
      )
      .subscribe({
        next: (val: string) => {
          let isEmpty = false;
          val.length ? (isEmpty = true) : (isEmpty = false);
          this.state.emittIsQueryEmpty(isEmpty);

          this.TickFilterOrder$.next(true);
        },
        error: err => console.error(err),
        complete: () => console.log('complete!')
      });

    this.cache.getValue(this.client.getAllServicesUrl).subscribe(res => {
      this.allServices = res || [];
    });

    this.state
      .getParameter('services')
      .pipe(
        takeUntil(this.componentDestroyed),
        catchError(error => of(error))
      )
      .subscribe(data => {
        this.taxiServices = data;
        this.selectedTaxiServices = data;
        this.createTaxiServisesSub();
      });

    this.productService.getProducts().subscribe(res => {
      this.Products = res.data;
      this.state.setParameter('products', res.data);
    });

    this.TickFilterOrder$.pipe(takeUntil(this.componentDestroyed), debounceTime(300)).subscribe(() => {
      this.FilterForOrders();
    });

    this.Ticker = timer(0, 60000);

    this.Ticker.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      if (!this.processing) {
        this.processing = true;
        let date = Date.now();
        this.filteredOrders = this.filteredOrders.map(order => {
          order.totalTime = (+order.searched_at - +order.created_at) / 1000 / 60;
          order.timeLeft = +order.searched_at - date;
          return order;
        });
        this.processing = false;
      }
    });

    this.filter$.next(true);

    this.ws.message.pipe(takeUntil(this.componentDestroyed)).subscribe(
      msg => {
        let res = JSON.parse(msg);
        switch (res.header.type) {
          case 'bulk':
            this.resetFilterAmount();
            this.orders = res.data.requests.map(item => this.timezone.toLocTime(item));
            this.TickFilterOrder$.next(true);
            break;
          case 'req':
            if (res.header.action == 'rcv') {
              let order = this.timezone.toLocTime(res.data);
              // this.countFilterAmount( order );
              this.orders.push(order);
              this.TickFilterOrder$.next(true);
            } else if (res.header.action == 'delete') {
              // shifting focus at the next order after remove previos order
              if (this.selectedOrder && this.selectedOrder.id == res.data.id) {
                this.filteredOrders = this.filteredOrders.filter(item => {
                  if (item.id == res.data.id) {
                    this.selectedOrder = this.filteredOrders[this.filteredOrders.indexOf(item) + 1];
                  }
                  return item;
                });
              }
              // //////
              this.orders = this.orders.filter(item => {
                if (item.id != res.data.id) {
                  return true;
                } else {
                  // this.removeFilterAmount( item );
                  return false;
                }
              });
              this.TickFilterOrder$.next(true);
            } else if (res.header.action == 'update') {
              let orders;
              if (res.data.status.toLowerCase() == 'completed') {
                // remove from list if status completed
                orders = this.orders.filter(item => {
                  if (item.id == res.data.id) {
                    // this.removeFilterAmount( item );
                    return false;
                  } else {
                    return item.id != res.data.id;
                  }
                });
              } else {
                let insert = false;
                let newOrder = this.timezone.toLocTime(res.data);
                orders = this.orders.map(item => {
                  if (item.id == newOrder.id) {
                    // this.removeFilterAmount( item );
                    newOrder.notifications = item.notifications;
                    item = newOrder;
                    insert = true;
                    if (
                      this.selectedOrder !== null &&
                      this.selectedOrder !== undefined &&
                      this.selectedOrder.id == newOrder.id
                    ) {
                      this.selectedOrder = newOrder;
                    }
                    // this.countFilterAmount( item );
                    item.is_locked = false; // TODO temporary step for unlock order updated current operator
                  }

                  return item;
                });
                if (!insert) {
                  orders.push(newOrder);
                }
              }
              this.orders = orders;
              this.TickFilterOrder$.next(true);
            } else if (res.header.action.toLowerCase() == 'lock') {
              this.orders = this.orders.map(item => {
                if (item.id == res.data.id) {
                  item['is_locked'] = true;
                  item['locked_by'] = res.data.locked_by;
                  item['locked_user'] = res.data.locked_user;
                }
                return item;
              });
              this.TickFilterOrder$.next(true);
            } else if (res.header.action.toLowerCase() == 'unlock') {
              this.orders = this.orders.map(item => {
                if (item.id == res.data.id) {
                  item['is_locked'] = false;
                  item['locked_by'] = '';
                  item['locked_user'] = {};
                }
                return item;
              });
              this.TickFilterOrder$.next(true);
            }
            break;
          case 'req_notification': {
            this.orders.forEach(item => {
              if (item.id == res.data.request_id) {
                item.notifications.push(res.data);
                item['notificationsLenght'] = item.notifications.length;
                this.cd.detectChanges();
              }
            });
            this.filteredOrders.forEach(item => {
              if (item.id == res.data.request_id) {
                item.notifications.push(res.data);
                item['notificationsLenght'] = item.notifications.length;
                this.cd.detectChanges();
              }
            });
            break;
          }
        }
        this.counOrdersInService(this.orders);
      },
      err => console.error(err)
    );

    this.wsSip.create('ws://127.0.0.1:7000');

    this.wsSip.message.pipe(takeUntil(this.componentDestroyed)).subscribe(data => {
      if (this.orderDetComp.dialogRef) {
        // order form already opened
        const compInst = this.orderDetComp.dialogRef.componentInstance;
        this.dialogRef = this.dialog.open(ModalCloseComponent, <MatDialogConfig>{
          data: {
            headerTemplate: 'WHAT_WILL_DO_WITH_OLD_ORDER',
            buttons: {
              yes: {
                title: 'SAVE',
                disabled:
                  !compInst.orderForm.valid ||
                  !compInst.fareStatus.status ||
                  compInst.saveProccess ||
                  compInst.isPreorderTimeValue ||
                  compInst.editTimeEnd
              },
              no: { title: 'CANCEL', disabled: false }
            }
          }
        });

        this.dialogRef
          .afterClosed()
          .pipe(takeUntil(this.componentDestroyed))
          .subscribe(res => {
            this.dialogRef = null;
            this.orderDetComp.openWindow = false;
            if (res == 'true') {
              // save
              this.orderDetComp.dialogRef = null;
              compInst.saveSingleOrder();
              this.handleCallFunc(data);
            } else {
              this.orderDetComp.dialogRef.close();
              this.orderDetComp.dialogRef = null;
              this.handleCallFunc(data);
            }
          });
      } else {
        this.handleCallFunc(data);
      }
    });

    this.haveSubscription = true;

    this.ws.createSub([
      { name: 'req' },
      {
        name: 'ticker',
        args: {
          interval: 300
        }
      }
    ]);

    function fn2workerURL(fn) {
      let blob = new Blob(['(' + fn.toString() + ')()'], { type: 'application/javascript' });
      return URL.createObjectURL(blob);
    }

    function workerBody() {
      addEventListener('message', e => {
        try {
          let orders = e.data.orders;
          let paramFilter = e.data.param;
          let services = e.data.services;
          let settings = e.data.param.settings;

          let obj = (() => {
            return {
              method: {
                phone: 0,
                app: 0
              },
              orderType: {
                current: 0,
                preordered: 0
              },
              status: {
                processing: 0,
                accepted: 0,
                waiting: 0,
                in_progress: 0,
                completed: 0,
                canceled: 0
              },
              payment: {
                cash: 0,
                bonus: 0,
                card: 0,
                phone: 0
              }
            };
          })();
          const sortingOrder = ['callsign', 'clientPhone', 'address', 'driverPhone', 'number'];
          let filteredOrders = orders
            .filter(order => {
              return e.data.param.selectedTaxiService.find(
                service =>
                  service &&
                  (service.id == order.service_id ||
                    (order.cab && !order.is_exclusive && service.id == order.cab.service_id))
              );
            })
            .map(order => {
              order.is_from_app ? obj.method.app++ : obj.method.phone++;
              obj.payment[order.payment_type]++;
              order.is_preorder ? obj.orderType.preordered++ : obj.orderType.current++;
              obj.status[order.status]++;
              return order;
            })
            .filter(order => {
              return paramFilter.myOrder && paramFilter.operatorID !== undefined
                ? order.operator_id == paramFilter.operatorID
                : true;
            })
            .map(order => {
              if (paramFilter.search !== null && !!paramFilter.search.length) {
                let check = new RegExp(paramFilter.search, 'gi');
                order.highlights = [];
                if (order.cab !== null) {
                  if (order.cab.driver.callsign && order.cab.driver.callsign == paramFilter.search) {
                    order.highlights.push('callsign');
                  }
                }
                if (paramFilter.search.length >= 3 && /^\d{3}/.test(paramFilter.search)) {
                  if (check.test(order.phone_number)) {
                    order.highlights.push('driverPhone');
                  }
                  if (check.test(order.passenger.phone_number)) {
                    order.highlights.push('clientPhone');
                  }
                }
                order.waypoints.some((item: any) => {
                  if (check.test(item.name)) {
                    order.highlights.push('address');
                  }
                });
                if (
                  order.cab &&
                  order.cab.vehicle &&
                  order.cab.vehicle.number &&
                  order.cab.vehicle.number.replace(/\D/g, '') == paramFilter.search
                ) {
                  order.highlights.push('number');
                }
                order.highlights = order.highlights.sort((a, b) => {
                  return sortingOrder.indexOf(a) - sortingOrder.indexOf(b);
                });
              } else {
                order.highlights = [''];
              }
              return order;
            })
            .filter(el => el.highlights.length)
            .filter(el => {
              if (Object.keys(paramFilter.filter).length == 0) {
                return true;
              } else {
                let item = {
                  method: el.is_from_app ? 'app' : 'phone',
                  orderType: el.is_preorder ? 'preordered' : 'current',
                  status: el.status,
                  payment: el.payment_type
                };
                let check = 0;
                for (let key of Object.keys(paramFilter.filter)) {
                  for (let key1 in item) {
                    if (key == key1) {
                      if (!!~paramFilter.filter[key].indexOf(item[key1])) {
                        check += 1;
                      }
                    }
                  }
                }
                if (check === Object.keys(paramFilter.filter).length) {
                  return true;
                }
              }
            })
            .map(order => {
              if (order.is_preorder) {
                order.visible_preorder =
                  order.is_preorder &&
                  order.status == 'processing' &&
                  new Date(order.assigned_at).valueOf() - new Date().valueOf() <
                    settings[order.service_id].requests_preorder_sending * 60 * 1000 &&
                  new Date(order.assigned_at).valueOf() > new Date().valueOf();
              }
              return order;
            })
            .sort((a, b) => {
              if (a.highlights[0]) {
                return sortingOrder.indexOf(a.highlights[0]) - sortingOrder.indexOf(b.highlights[0]);
              }
            })
            .sort((a, b) => {
              if (a.is_holding && b.is_holding) {
                return new Date(b.created_at).valueOf() - new Date(a.created_at).valueOf();
              }
              if (a.is_holding) {
                return -1;
              }
              if (b.is_holding) {
                return 1;
              }
              if (a.is_preorder && a.visible_preorder) {
                if (b.is_preorder && b.visible_preorder) {
                  return new Date(a.assigned_at).valueOf() - new Date(b.assigned_at).valueOf();
                } else {
                  return -1;
                }
              }
              if (b.is_preorder && b.visible_preorder) {
                return 1;
              }
              if (
                (a.visible_preorder == undefined || a.status.processing) &&
                (b.visible_preorder == undefined || b.status.processing)
              ) {
                return new Date(b.created_at).valueOf() - new Date(a.created_at).valueOf();
              }

              if (!a.visible_preorder && a.is_preorder) {
                if (b.is_preorder && !b.visible_preorder) {
                  return new Date(a.assigned_at).valueOf() - new Date(b.assigned_at).valueOf();
                } else {
                  return 1;
                }
              }

              if (b.is_preorder && !b.visible_preorder) {
                return -1;
              }
            });

          if (services.length) {
            filteredOrders.forEach(itemOrder => {
              services.forEach(item => {
                if (item.id === itemOrder.service_id) {
                  itemOrder.service = item;
                }
              });
            });
          }

          postMessage({ orders: filteredOrders, filters: obj }, undefined);
        } catch (ex) {
          postMessage({ error: ex }, undefined);
        }
      });
    }

    this.WebWorker = new Worker(fn2workerURL(workerBody));

    this.WebWorker.addEventListener('message', e => {
      if (e.data.error) {
        console.error(e.data.error);
      }
      /*this.filteredOrders = e.data;*/
      this.filterAmount = e.data.filters;
      if (!this.processing) {
        this.processing = true;
        let date = Date.now();
        this.filteredOrders = e.data.orders.map(order => {
          order.totalTime = (+order.searched_at - +order.created_at) / 1000 / 60;
          order.timeLeft = +order.searched_at - date;
          // this.countFilterAmount(order, copy)
          return order;
        });
        this.processing = false;
      }

      if (!this.selectedOrder) {
        this.selectedOrder = this.filteredOrders[0];
      } else {
        let conditionOrder = this.filteredOrders.some(item => item.id == this.selectedOrder.id);
        if (!conditionOrder) {
          this.selectedOrder = this.filteredOrders[0];
        }
      }

      if (!this.OrderReady) {
        this.OrderReady = true;
      }
    });
  }

  handleCallFunc(data): void {
    let curOrders = this.orders.filter(item => {
      return !!~item.passenger.phone_number.indexOf(data.phone_number);
    });
    if (curOrders.length) {
      this.selectedOrder = curOrders[curOrders.length - 1];
      setTimeout(() => {
        this.orderDetComp.editOrder();
      }, 500);
    } else {
      setTimeout(() => {
        this.orderDetComp.TelCreateOrder(data);
      }, 500);
    }
  }

  getEmptyAmount(): AmountFilter {
    return {
      method: {
        phone: 0,
        app: 0
      },
      orderType: {
        current: 0,
        preordered: 0
      },
      status: {
        processing: 0,
        accepted: 0,
        waiting: 0,
        in_progress: 0,
        completed: 0,
        canceled: 0
      },
      payment: {
        cash: 0,
        card: 0,
        bonus: 0,
        phone: 0
      }
    };
  }

  ngOnDestroy() {
    this.componentDestroyed.next(true);
    this.componentDestroyed.unsubscribe();
    this.unsubscribeDashboard();
    this.wsSip.close();
  }

  unsubscribeDashboard() {
    if (this.haveSubscription) {
      this.ws.closeSub([{ name: 'req' }, { name: 'ticker' }]);
      this.haveSubscription = false;
    }
  }

  changeFilters(key, prod) {
    if (this.clearFilter) {
      this.clearFilter = false;
    }
    this.filters[key][prod] = !this.filters[key][prod];
    this.filter$.next(this.filters);
  }

  FilterForOrders() {
    const param = {
      filter: this.activeFilter,
      search: this.search,
      selectedTaxiService: this.selectedTaxiServices,
      myOrder: this.myOrders,
      operatorID: this.operatorID,
      settings: this.settings.settings
    };

    this.WebWorker.postMessage({
      orders: this.orders,
      param: param,
      services: this.allServices
    });
  }

  checkStatus(obj) {
    switch (obj.status) {
      case 'processing':
        return 1;
      case 'accepted':
        return 2;
      case 'waiting':
        return 3;
      case 'in_progress':
        return 4;
    }
  }

  toogleNoticeForm() {
    this.dialog.open(DriverNoticeComponent, {
      disableClose: true
    });
  }

  createOrder() {
    this.orderDetComp.createOrder();
  }

  setFilterAmount(obj): void {
    this.filterAmount = obj;
  }

  selectSingleTaxiServices(service) {
    this.selectedTaxiServices = [service];
  }

  changeSelectedTaxiServices(product) {
    if (this.selectedTaxiServices.indexOf(product) + 1) {
      this.selectedTaxiServices = this.selectedTaxiServices.filter(el => el.id != product.id);
    } else {
      this.selectedTaxiServices.push(product);
    }
    /*this.selectedTaxiServices.map(service => {
      const obj = this.driverNumberByServices[service.id];
      if (obj) {
        this.driversNumber.total += obj.total;
        this.driversNumber.active += obj.active;
      }
    })

    console.log(this.driversNumber, this.driverNumberByServices);*/

    this.markForFilterOrders();
    console.log('selected servs', this.selectedTaxiServices);
  }

  resetFilterAmount() {
    this.filterAmount = {
      method: {
        phone: 0,
        app: 0
      },
      orderType: {
        current: 0,
        preordered: 0
      },
      status: {
        processing: 0,
        accepted: 0,
        waiting: 0,
        in_progress: 0,
        completed: 0,
        canceled: 0
      },
      payment: {
        cash: 0,
        card: 0,
        bonus: 0,
        phone: 0
      }
    };
  }

  /*removeFilterAmount ( item ) {
    item.is_from_app ? this.filterAmount.method.app-- : this.filterAmount.method.phone--;
    item.is_card ? this.filterAmount.payment.cashless-- : this.filterAmount.payment.cash--;
    item.is_preorder ? this.filterAmount.orderType.preordered-- : this.filterAmount.orderType.current--;
    this.filterAmount.status[item.status]--;
  }*/

  clearFilters() {
    this.clearFilter = !this.clearFilter;
    this.clearFilter
      ? (this.filters = {
          method: {
            phone: false,
            app: false
          },
          orderType: {
            preordered: false,
            current: false
          },
          status: {
            processing: false,
            accepted: false,
            waiting: false,
            in_progress: false,
            completed: false
          },
          payment: {
            cash: false,
            card: false,
            bonus: false,
            phone: false
          }
        })
      : (this.filters = {
          method: {
            phone: true,
            app: true
          },
          orderType: {
            preordered: true,
            current: true
          },
          status: {
            processing: true,
            accepted: true,
            waiting: true,
            in_progress: true,
            completed: true
          },
          payment: {
            cash: true,
            card: true,
            bonus: true,
            phone: false
          }
        });
    this.filter$.next(this.filters);
  }

  markForFilterOrders() {
    this.TickFilterOrder$.next(true);
  }

  setCurrentOrder(order: Order): void {
    this.selectedOrder = order;
  }

  editCurrentOrder(order: Order): void {
    this.selectedOrder = order;
    this.orderDetComp.editOrder();
  }

  goArchive() {
    this.router.navigate(['/orders-archive']);
  }

  toggleDriversStatus() {
    this.driversStatus = !this.driversStatus;
    this.dialog.openDialogs.length = 1;
  }

  closeDriversStatus() {
    this.driversStatus = false;
    this.dialog.openDialogs.length = 0;
  }

  changeHoldStatus(status) {
    this.dialogStatus.inputFocused = status;
  }

  private createTaxiServisesSub(): void {
    const reqs = this.taxiServices.map(service => this.taxiServiceInfoService.getInfoAboutService(service.id));
    forkJoin(reqs).subscribe(this.taxiServicesSubFunc);

    interval(31000)
      .pipe(
        takeUntil(this.componentDestroyed),
        mergeMap(() => {
          const reqArray = this.taxiServices.map(service =>
            this.taxiServiceInfoService.getInfoAboutService(service.id)
          );
          return forkJoin(reqArray);
        })
      )
      .subscribe(this.taxiServicesSubFunc);
  }

  private taxiServicesSubFunc = (res: any[]) => {
    this.cabsOnlineByService = {};
    this.taxiServices.forEach((service, index) => {
      this.cabsOnlineByService[service.id] = {
        ...res[index]
      };
    });
  };

  private counOrdersInService(orders) {
    const len = orders.length;
    this.ordersCountByService = {};
    for (let x = 0; x < len; x++) {
      if (orders[x].status !== 'completed' && orders[x].status !== 'cancaled') {
        const serviceID = orders[x].service_id;
        if (serviceID in this.ordersCountByService) {
          this.ordersCountByService[serviceID]++;
        } else {
          this.ordersCountByService[serviceID] = 1;
        }
      }
    }
    // this.ordersByService$.next(this.ordersCountByService);
  }

  /*timeSort ( a, b ) {
   return Date.parse( a.created_at ) - Date.parse( b.created_at );
   }

   sortOrders ( type ) {
   if ( this.conveyor ) {
   return;
   }
   this.currentSort = type;
   if ( type == 'time' ) {
   this.sortDirection.time = !this.sortDirection.time;
   this.sortDirection.status = false;
   }
   if ( type == 'status' ) {
   this.sortDirection.status = !this.sortDirection.status;
   this.sortDirection.time = false;
   }
   this.filteredOrders.sort( ( a, b ) => {
   switch ( type ) {
   case 'time':
   return this.timeSort( a, b );
   case 'status':
   return this.statusSort( a, b );
   }
   } );
   }

   statusSort ( a, b ) {
   const statA = this.checkStatus( a );
   const statB = this.checkStatus( b );
   return statB - statA;
   }

   filterOrders ( orders, filter ) {
   let orderFilter = orders.filter( ( obj ) => {
   let item = {
   method: obj.is_from_app ? 'app' : 'phone',
   orderType: obj.is_preorder ? 'preordered' : 'current',
   status: obj.status,
   payment: obj.is_card ? 'cashless' : 'cash'
   };
   let check = 0;
   for ( let key of Object.keys( filter ) ) {
   for ( let key1 in item ) {
   if ( key == key1 ) {
   if ( !!~filter[key].indexOf( item[key1] ) ) {
   check += 1;
   }
   }
   }
   }
   if ( check === Object.keys( filter ).length ) {
   return true;
   }
   } );
   return orderFilter;
   }*/
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard/dashboard.component.ts